(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gj-homepage"] && !Shopify.designMode) return;
  try {
    
  const gjNavItems = Array.from(document.querySelectorAll('.gj-home__nav-item'));

  gjNavItems.forEach((item) => {
    const summary = item.querySelector('summary');

    item.addEventListener('toggle', () => {
      if (!item.open) return;
      gjNavItems.forEach((otherItem) => {
        if (otherItem !== item) otherItem.open = false;
      });
    });

    item.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        item.open = false;
        summary.focus();
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.gj-home__nav-item')) return;
    gjNavItems.forEach((item) => {
      item.open = false;
    });
  });

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.gj-home__nav a').forEach((link) => {
      link.addEventListener('click', (event) => {
        const destination = link.href;
        if (!destination) return;
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(destination);
      });
    });
  }

  const gjSearchInput = document.querySelector('#GJHomeSearch');
  const gjPredictive = document.querySelector('#GJHomePredictive');

  if (gjSearchInput && gjPredictive) {
    let gjSearchTimer;
    let gjSearchController;
    let gjActiveIndex = -1;

    const gjClosePredictive = () => {
      gjPredictive.hidden = true;
      gjPredictive.replaceChildren();
      gjSearchInput.setAttribute('aria-expanded', 'false');
      gjSearchInput.removeAttribute('aria-activedescendant');
      gjActiveIndex = -1;
    };

    const gjSetActiveResult = (index) => {
      const results = Array.from(gjPredictive.querySelectorAll('[role="option"]'));
      if (!results.length) return;
      gjActiveIndex = Math.max(0, Math.min(index, results.length - 1));
      results.forEach((result, resultIndex) => result.setAttribute('aria-selected', resultIndex === gjActiveIndex ? 'true' : 'false'));
      const activeResult = results[gjActiveIndex];
      gjSearchInput.setAttribute('aria-activedescendant', activeResult.id);
      activeResult.scrollIntoView({ block: 'nearest' });
    };

    const gjRenderProducts = (products, query) => {
      gjPredictive.replaceChildren();
      const list = document.createElement('div');
      list.className = 'gj-home__predictive-list';

      products.forEach((product, index) => {
        const link = document.createElement('a');
        link.className = 'gj-home__predictive-item';
        link.href = product.url;
        link.id = 'GJHomeResult-' + index;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');

        const imageUrl = product.featured_image && product.featured_image.url;
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = product.featured_image.alt || '';
          image.width = 64;
          image.height = 64;
          image.loading = 'lazy';
          link.appendChild(image);
        }

        const title = document.createElement('strong');
        title.textContent = product.title;
        link.appendChild(title);

        if (product.price) {
          const price = document.createElement('small');
          price.textContent = product.price;
          link.appendChild(price);
        }

        list.appendChild(link);
      });

      gjPredictive.appendChild(list);
      const allResults = document.createElement('a');
      allResults.className = 'gj-home__predictive-all';
      allResults.href = '/search?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last';
      allResults.textContent = 'See all results for “' + query + '” →';
      gjPredictive.appendChild(allResults);
      gjPredictive.hidden = false;
      gjSearchInput.setAttribute('aria-expanded', 'true');
    };

    const gjLoadSuggestions = async (query) => {
      if (gjSearchController) gjSearchController.abort();
      gjSearchController = new AbortController();
      gjPredictive.innerHTML = '<div class="gj-home__predictive-status"><span class="gj-home__predictive-spinner" aria-label="Loading"></span></div>';
      gjPredictive.hidden = false;
      gjSearchInput.setAttribute('aria-expanded', 'true');

      const normalizedInput = query.toLowerCase();
      const manufacturerNames = ['ford', 'chevrolet', 'toyota', 'mazda', 'honda', 'nissan', 'hyundai', 'kia', 'dodge', 'ram', 'jeep', 'gmc', 'buick', 'chrysler', 'subaru', 'volkswagen', 'bmw', 'mercedes', 'audi', 'lexus', 'acura', 'infiniti', 'cadillac', 'mitsubishi', 'volvo'];
      const manufacturerMatch = normalizedInput.length >= 3 ? manufacturerNames.find((name) => name.startsWith(normalizedInput)) : null;
      const searchQuery = manufacturerMatch || query;

      const params = new URLSearchParams({
        q: searchQuery,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'hide',
        'resources[options][fields]': 'title,product_type,variants.title,tag'
      });

      try {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const response = await fetch(root + 'search/suggest.json?' + params.toString(), { signal: gjSearchController.signal });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        let products = data.resources && data.resources.results ? data.resources.results.products || [] : [];

        if (query.toLowerCase() === 'open') {
          const priorityQueries = ['drive thru open', 'grand opening'];
          const priorityGroups = await Promise.all(priorityQueries.map(async (priorityQuery) => {
            const priorityParams = new URLSearchParams({
              q: priorityQuery,
              'resources[type]': 'product',
              'resources[limit]': '6',
              'resources[options][unavailable_products]': 'hide',
              'resources[options][fields]': 'title,product_type,variants.title,tag'
            });
            const priorityResponse = await fetch(root + 'search/suggest.json?' + priorityParams.toString(), { signal: gjSearchController.signal });
            if (!priorityResponse.ok) return [];
            const priorityData = await priorityResponse.json();
            return priorityData.resources && priorityData.resources.results ? priorityData.resources.results.products || [] : [];
          }));

          const preferredProducts = priorityGroups.flat().filter((product) => {
            const title = product.title.toLowerCase();
            return title.includes('drive thru') || title.startsWith('grand opening');
          });
          const seenUrls = new Set();
          products = [...preferredProducts, ...products].filter((product) => {
            if (seenUrls.has(product.url)) return false;
            seenUrls.add(product.url);
            return true;
          }).slice(0, 6);
        } else {
          const normalizedQuery = searchQuery.toLowerCase();
          products = products.map((product, index) => {
            const title = product.title.toLowerCase();
            let rank = 3;
            if (title === normalizedQuery) rank = 0;
            else if (title.startsWith(normalizedQuery)) rank = 1;
            else if (title.includes(normalizedQuery)) rank = 2;
            return { product, index, rank };
          }).sort((a, b) => a.rank - b.rank || a.index - b.index).map((entry) => entry.product);
        }
        if (gjSearchInput.value.trim() !== query) return;
        if (products.length) gjRenderProducts(products, searchQuery);
        else gjClosePredictive();
      } catch (error) {
        if (error.name !== 'AbortError') gjClosePredictive();
      }
    };

    gjSearchInput.addEventListener('input', () => {
      const query = gjSearchInput.value.trim();
      if (/^led/i.test(query)) {
        gjPredictive.innerHTML = '<div class="gj-home__predictive-list"><a class="gj-home__predictive-item" href="/#GJLedHeading"><span aria-hidden="true" style="display:grid;place-items:center;width:64px;height:64px;border-radius:6px;background:#082f55;color:#fff;font-weight:900">LED</span><span><strong>McClain LED Signs</strong><small>P10 displays, 8,500-nit brightness, automatic brightness control, and 4G capability</small></span><span>View &rarr;</span></a></div>';
        gjPredictive.hidden = false;
        gjSearchInput.setAttribute('aria-expanded', 'true');
        return;
      }
      window.clearTimeout(gjSearchTimer);
      if (query.length < 3) {
        if (gjSearchController) gjSearchController.abort();
        gjClosePredictive();
        return;
      }
      gjSearchTimer = window.setTimeout(() => gjLoadSuggestions(query), 180);
    });

    gjSearchInput.addEventListener('keydown', (event) => {
      const results = gjPredictive.querySelectorAll('[role="option"]');
      if (event.key === 'ArrowDown' && results.length) {
        event.preventDefault();
        gjSetActiveResult(gjActiveIndex + 1);
      } else if (event.key === 'ArrowUp' && results.length) {
        event.preventDefault();
        gjSetActiveResult(gjActiveIndex <= 0 ? results.length - 1 : gjActiveIndex - 1);
      } else if (event.key === 'Enter' && gjActiveIndex >= 0 && results[gjActiveIndex]) {
        event.preventDefault();
        window.location.assign(results[gjActiveIndex].href);
      } else if (event.key === 'Escape') {
        gjClosePredictive();
      }
    });

    document.addEventListener('click', (event) => {
      if (!gjPredictive.contains(event.target) && event.target !== gjSearchInput) gjClosePredictive();
    });
  }

document.querySelectorAll('a[href="#GJLedSpanish"]').forEach((link) => {
  link.addEventListener('click', (event) => {
    const details = document.querySelector('#GJLedSpanish');
    if (!details) return;
    event.preventDefault();
    details.open = true;
    details.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
